/* ========================================================================
   Use module pattern to encapsulate JavaScript: http://bit.ly/2jM4ptd
   Define custom namespace
 ========================================================================== */

var app = app || {};
